import hyRequest from '@/service'
import { IDataType } from '@/service/types'

export function getPageListData(url: string, queryInfo: any,methods = 'post') { 
  return hyRequest[methods]<IDataType>({
    url: url,
    data: queryInfo
  })
}

export function deletePageData(url: string) {
  return hyRequest.delete<IDataType>({
    url: url
  })
}
export function createPageData(url: string, newData: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: newData
  })
}

export function editPageData(url: string, editData: any) {
  return hyRequest.patch<IDataType>({
    url: url,
    data: editData
  })
}
export function editTeacher(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function getParentReservationInfo(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function getTeacherFreeTime(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function publicNotice(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function getNotice(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function editNotice(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function getTree(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function getDictData(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function changeDictData(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
export function deleteDictData(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}

export function uploadFile(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo,
    headers:{
      'Content-Type':'multipart/form-data'
    }
  })
}
// 运营商列表
export function getOperatorTree(url: string, queryInfo: any) {
  return hyRequest.get<IDataType>({
    url: url,
    data: queryInfo
  })
}
// 编辑运营商
export function changeOperator(url: string, queryInfo: any,methods = 'post') {
  return hyRequest[methods]<IDataType>({
    url: url,
    data: queryInfo
  })
}
// 删除运营商
export function deleteOperator(url: string) {
  return hyRequest.delete<IDataType>({
    url: url
  })
}
//获取地理区域
export function getGeoArea(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//获取科目价格列表
export function getPriceList(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//修改价格
export function editPrice(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//获取校区列表 
export function getClassRoomList(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//修改校区/教师
export function editClassTeath(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//删除校区/教师
export function deleteClassTeath(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//新增校区/教师
export function addClassTeath(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//生成小程序码
export function getWxaCode(url: string, queryInfo: any, responseType?: 'blob') {
  return hyRequest.post<IDataType | Blob>({
    url: url,
    data: queryInfo,
    responseType: responseType
  })
}
//获取排课列表 
export function getCourseSchedulingList(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//新增排课
export function addCourseScheduling(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//获取下拉老师列表
export function getTeacherList(url: string) {
  return hyRequest.post<IDataType>({
    url: url,
  })
}

//获取下拉家长列表
export function fetchGetParentList() {
  return hyRequest.post<IDataType>({
    url: 'pc/userInfo/parentDropDown',
  })
}

// 获取教师课时统计
export function fetchGetTeacherInfo(data) {
  return hyRequest.post<IDataType>({
    url: 'pc/info/teacherClassCount',
    data
  })
}

// 根据教师获取科目信息
export function fetchGetProject(userId: string) {
  return hyRequest.post<IDataType>({
    url: 'app/dictionary/getSubjectTree',
    data: {
      userId
    }
  })
}

// 取消未上课课时
export function fetchSubmitCancelClass(data) {
  return hyRequest.post<IDataType>({
    url: 'app/reservation/pc/cancel',
    data
  })
}

// 获取校区地区
export function fetchGetAppClassRoomList() {
  return hyRequest.post<IDataType>({
    url: 'app/classRoom/managerCampusList',
  })
}

// 帮预约课程
export function fetchSubmitClass(data) {
  return hyRequest.post<IDataType>({
    url: 'app/reservation/pc/submit',
    data
  })
}

//根据老师获取预约时间
export function getAppointmentTime(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//根据预约时间选择校区
export function getCampusList(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//修改上课状态
export function changeClassStatus(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//付费列表
export function getPayList(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}

//拉黑老师
export function blackTeacher(url: string, queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: url,
    data: queryInfo
  })
}
//删除老师
export function deleteTeacher(url: string) {
  return hyRequest.delete<IDataType>({
    url: url
  })
}